<div class="mef-pending-badge" *ngIf="readOnly && expense.pendingSync">
  <ion-icon name="time-outline"></ion-icon>{{ 'PENDING_SYNC' | translate }}
</div>

<div class="mef-grid">
  <div class="mef-field">
    <div class="mef-label">{{ 'STATUS' | translate }}</div>
    <div class="mef-value mef-value--muted">{{ statusLabel }}</div>
  </div>

  <div class="mef-field" *ngIf="!readOnly || expense.expenseDate" [class.mef-field--invalid]="errorFor('date')">
    <div class="mef-label">{{ 'MEETING_EXPENSE_DATE' | translate }}<ion-icon class="mandatory-icon"></ion-icon></div>
    <button type="button" class="mef-value mef-value--button" [disabled]="readOnly" (click)="openDatePicker()">
      <span>{{ dateText }}</span>
      <ion-icon *ngIf="!readOnly" name="chevron-down-outline"></ion-icon>
    </button>
    <div class="mef-error" *ngIf="errorFor('date') as error">{{ error | translate }}</div>
  </div>

  <div class="mef-field mef-customer" #customerWrap [hidden]="readOnly && !expense.contactId">
    <ind-form-field [viewData]="contactFormField"></ind-form-field>
  </div>

  <div class="mef-field" *ngIf="!readOnly || expense.typeName" [class.mef-field--invalid]="errorFor('type')">
    <div class="mef-label">{{ 'MEETING_EXPENSE_TYPE' | translate }}<ion-icon class="mandatory-icon"></ion-icon></div>
    <button type="button" class="mef-value mef-value--button" [disabled]="readOnly" (click)="pickType($event)">
      <span [class.mef-placeholder]="!expense.typeName">{{ expense.typeName || ('SELECT_TYPE' | translate) }}</span>
      <ion-icon *ngIf="!readOnly" name="chevron-down-outline"></ion-icon>
    </button>
    <div class="mef-error" *ngIf="errorFor('type') as error">{{ error | translate }}</div>
  </div>

  <div class="mef-field" *ngIf="showSubtype && (!readOnly || expense.subtypeName)" [class.mef-field--invalid]="errorFor('subtype')">
    <div class="mef-label">{{ 'MEETING_EXPENSE_SUBTYPE' | translate }}<ion-icon class="mandatory-icon"></ion-icon></div>
    <button type="button" class="mef-value mef-value--button" [disabled]="readOnly" (click)="pickSubtype($event)">
      <span [class.mef-placeholder]="!expense.subtypeName">{{ expense.subtypeName || ('MEETING_EXPENSE_SELECT_SUBTYPE' | translate) }}</span>
      <ion-icon *ngIf="!readOnly" name="chevron-down-outline"></ion-icon>
    </button>
    <div class="mef-error" *ngIf="errorFor('subtype') as error">{{ error | translate }}</div>
  </div>

  <div class="mef-field" *ngIf="!readOnly || expense.amount != null" [class.mef-field--invalid]="errorFor('amount')">
    <div class="mef-label">{{ 'MEETING_EXPENSE_AMOUNT_WITH_CURRENCY' | translate: { currency: currencyLabel } }}<ion-icon class="mandatory-icon"></ion-icon></div>
    <div class="mef-amount">
      <input class="mef-value mef-input" type="number" inputmode="decimal" min="0" step="any" placeholder="0.00"
             [readonly]="readOnly" [value]="amountText"
             (input)="onAmountInput($any($event.target).value)" (blur)="onAmountBlur()">
      <div class="mef-stepper" *ngIf="!readOnly">
        <button type="button" class="mef-stepper-btn" (click)="stepAmount(1)"><ion-icon name="chevron-up-outline"></ion-icon></button>
        <button type="button" class="mef-stepper-btn" [disabled]="!canDecrement" (click)="stepAmount(-1)"><ion-icon name="chevron-down-outline"></ion-icon></button>
      </div>
    </div>
    <div class="mef-error" *ngIf="errorFor('amount') as error">{{ error | translate }}</div>
  </div>
</div>

<sdr-notes-section
  *ngIf="readOnly && expense.notes.length"
  [sdrId]="null"
  [existingNotes]="expense.notes"
  [readOnly]="true"
  [showSectionHeader]="false"
  [notesConfig]="notesConfig">
</sdr-notes-section>
<sdr-notes-section
  *ngIf="!readOnly"
  [sdrId]="null"
  [existingNotes]="[]"
  [readOnly]="false"
  [showSectionHeader]="false"
  [notesConfig]="notesConfig"
  [initialStagedNotes]="seededNotes"
  (stagedNoteAdded)="onStagedNoteAdded($event)"
  (stagedNoteEdited)="onStagedNoteEdited($event)"
  (stagedNoteRemoved)="onStagedNoteRemoved($event)">
</sdr-notes-section>
